import './App.css';

function App() {
  return (
    <div className="App">
      <h1>Manutenzione in corso</h1>
    </div>
  );
}

export default App;
